// Its own entry point so request builders can read the branch without loading
// the HTTP client.
/**
 * Active location (branch). When set, EVERY request carries an
 * `X-Location-Id` header and the API scopes location-aware reads and writes to
 * that branch (`LocationGuard` + `@ActiveLocation()`).
 *
 * Unlike the admin override this is NOT path-restricted. The override is a
 * privileged escape hatch whose blast radius has to be bounded; the active
 * location is the ordinary state of the whole app: the user is always looking
 * at exactly one branch, and an endpoint that ignores the header is unchanged
 * by receiving it. A path allowlist here would instead be a list to forget to
 * update every time an endpoint becomes location-aware.
 *
 * `null` (the default) means "no branch selected" and the API falls back to
 * org-wide, which is the behaviour every endpoint had before this existed.
 */
let activeLocationId = null;
/**
 * Set (or clear, with `null`) the branch every subsequent request is scoped to.
 * Called by the frontend's `use-active-location` seam.
 */
export function setActiveLocationId(locationId) {
    activeLocationId = locationId;
}
/** The branch currently being sent on requests, if any. */
export function getActiveLocationId() {
    return activeLocationId;
}
//# sourceMappingURL=index.js.map